import { initializeApp } from "firebase/app";
import {
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
  signOut,
} from "firebase/auth";
import {
  getFirestore,
  collection,
  addDoc,
  query,
  where,
  getDoc,
  doc,
  setDoc,
  updateDoc,
} from "firebase/firestore";
import "firebase/compat/firestore";
import "firebase/compat/auth";

export const firebaseConfig = {
  apiKey: "AIzaSyBBHiu5VwYDEa846qybcM_Uj561BxYfD2w",
  authDomain: "thesis-41e32.firebaseapp.com",
  projectId: "thesis-41e32",
  storageBucket: "thesis-41e32.appspot.com",
  messagingSenderId: "852070852573",
  appId: "1:852070852573:web:1b18d079352e386e167834",
  measurementId: "G-2Q6P1D54P9",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const firestore = getFirestore(app);
const googleProvider = new GoogleAuthProvider();

const signInWithGoogle = async () => {
  try {
    const res = await signInWithPopup(auth, googleProvider);
    const user = res.user;

    // Use the UID as the document ID
    const userId = user.uid;
    const userDocRef = doc(db, "users", userId);

    // Get the current timestamp as the registration date
    const registrationDate = new Date();

    // Save user data to Firestore including the registration date
    await setDoc(doc(db, "users", userId), {
      uid: userId,
      name: user.displayName,
      authProvider: "google",
      email: user.email,
      registrationDate,
    });
    const newCollectionRef = collection(userDocRef, "topic");
    const newData = {
      quizFinished: false,
    };
    await setDoc(doc(newCollectionRef, userId), newData);

    const newCollectionRefBraking = collection(userDocRef, "braking");
    const newData2 = {
      quizFinished: false,
    };
    await setDoc(doc(newCollectionRefBraking, userId), newData2);
    const newCollectionRefFollowing = collection(userDocRef, "following");
    const newData3 = {
      quizFinished: false,
    };
    await setDoc(doc(newCollectionRefFollowing, userId), newData3);

    const newCollectionRefSpeed = collection(userDocRef, "speed");
    const newData4 = {
      quizFinished: false,
    };
    await setDoc(doc(newCollectionRefSpeed, userId), newData4);

    const newCollectionRefRight = collection(userDocRef, "right");
    const newData5 = {
      quizFinished: false,
    };
    await setDoc(doc(newCollectionRefRight, userId), newData5);

    const newCollectionRefWarning = collection(userDocRef, "warning");
    const newData6 = {
      quizFinished: false,
    };
    await setDoc(doc(newCollectionRefWarning, userId), newData6);

    const newCollectionRefRegulatory = collection(userDocRef, "regulatory");
    const newData7 = {
      quizFinished: false,
    };
    await setDoc(doc(newCollectionRefRegulatory, userId), newData7);

    const newCollectionRefInformative = collection(userDocRef, "informative");
    const newData8 = {
      quizFinished: false,
    };
    await setDoc(doc(newCollectionRefInformative, userId), newData8);

    const newCollectionRefPavement = collection(userDocRef, "pavement");
    const newData9 = {
      quizFinished: false,
    };
    await setDoc(doc(newCollectionRefPavement, userId), newData9);

    const newCollectionRefDouble = collection(userDocRef, "double");
    const newData10 = {
      quizFinished: false,
    };
    await setDoc(doc(newCollectionRefDouble, userId), newData10);

    const newCollectionRefCrosswalk = collection(userDocRef, "crosswalk");
    const newData11 = {
      quizFinished: false,
    };
    await setDoc(doc(newCollectionRefCrosswalk, userId), newData11);

    const newCollectionRefRoadrage = collection(userDocRef, "roadrage");
    const newData12 = {
      quizFinished: false,
    };
    await setDoc(doc(newCollectionRefRoadrage, userId), newData12);

    const newCollectionRefDefensive = collection(userDocRef, "defensive");
    const newData13 = {
      quizFinished: false,
    };
    await setDoc(doc(newCollectionRefDefensive, userId), newData13);

    const newCollectionRefTips = collection(userDocRef, "tips");
    const newData14 = {
      quizFinished: false,
    };
    await setDoc(doc(newCollectionRefTips, userId), newData14);

    const newCollectionRefLicensing = collection(userDocRef, "licensing");
    const newData15 = {
      quizFinished: false,
    };
    await setDoc(doc(newCollectionRefLicensing, userId), newData15);

    const newCollectionRefWhiteline = collection(userDocRef, "whiteline");
    const newData16 = {
      quizFinished: false,
    };
    await setDoc(doc(newCollectionRefWhiteline, userId), newData16);

    const newCollectionRefChanging = collection(userDocRef, "changing");
    const newData17 = {
      quizFinished: false,
    };
    await setDoc(doc(newCollectionRefChanging, userId), newData17);

    const newCollectionRefOvertaking = collection(userDocRef, "overtaking");
    const newData18 = {
      quizFinished: false,
    };
    await setDoc(doc(newCollectionRefOvertaking, userId), newData18);

    const newCollectionRefDriving = collection(userDocRef, "driving");
    const newData19 = {
      quizFinished: false,
    };
    await setDoc(doc(newCollectionRefDriving, userId), newData19);
  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};

const logInWithEmailAndPassword = async (email, password) => {
  try {
    await signInWithEmailAndPassword(auth, email, password);
  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};

const registerWithEmailAndPassword = async (name, email, password) => {
  try {
    const res = await createUserWithEmailAndPassword(auth, email, password);
    const user = res.user;
    const userId = user.uid; // Use the UID as the document ID
    const userDocRef = doc(db, "users", userId);

    // Get the current timestamp as the registration date
    const registrationDate = new Date();

    // Save user data to Firestore including the registration date
    await setDoc(doc(db, "users", userId), {
      uid: userId,
      name,
      authProvider: "local",
      email,
      registrationDate,
    });
    const newCollectionRef = collection(userDocRef, "topic");
    const newData = {
      quizFinished: false,
    };
    await setDoc(doc(newCollectionRef, userId), newData);

    const newCollectionRefBraking = collection(userDocRef, "braking");
    const newData2 = {
      quizFinished: false,
    };
    await setDoc(doc(newCollectionRefBraking, userId), newData2);

    const newCollectionRefFollowing = collection(userDocRef, "following");
    const newData3 = {
      quizFinished: false,
    };
    await setDoc(doc(newCollectionRefFollowing, userId), newData3);

    const newCollectionRefSpeed = collection(userDocRef, "speed");
    const newData4 = {
      quizFinished: false,
    };
    await setDoc(doc(newCollectionRefSpeed, userId), newData4);

    const newCollectionRefRight = collection(userDocRef, "right");
    const newData5 = {
      quizFinished: false,
    };
    await setDoc(doc(newCollectionRefRight, userId), newData5);

    const newCollectionRefWarning = collection(userDocRef, "warning");
    const newData6 = {
      quizFinished: false,
    };
    await setDoc(doc(newCollectionRefWarning, userId), newData6);

    const newCollectionRefRegulatory = collection(userDocRef, "regulatory");
    const newData7 = {
      quizFinished: false,
    };
    await setDoc(doc(newCollectionRefRegulatory, userId), newData7);

    const newCollectionRefInformative = collection(userDocRef, "informative");
    const newData8 = {
      quizFinished: false,
    };
    await setDoc(doc(newCollectionRefInformative, userId), newData8);

    const newCollectionRefPavement = collection(userDocRef, "pavement");
    const newData9 = {
      quizFinished: false,
    };
    await setDoc(doc(newCollectionRefPavement, userId), newData9);

    const newCollectionRefDouble = collection(userDocRef, "double");
    const newData10 = {
      quizFinished: false,
    };
    await setDoc(doc(newCollectionRefDouble, userId), newData10);

    const newCollectionRefCrosswalk = collection(userDocRef, "crosswalk");
    const newData11 = {
      quizFinished: false,
    };
    await setDoc(doc(newCollectionRefCrosswalk, userId), newData11);

    const newCollectionRefRoadrage = collection(userDocRef, "roadrage");
    const newData12 = {
      quizFinished: false,
    };
    await setDoc(doc(newCollectionRefRoadrage, userId), newData12);

    const newCollectionRefDefensive = collection(userDocRef, "defensive");
    const newData13 = {
      quizFinished: false,
    };
    await setDoc(doc(newCollectionRefDefensive, userId), newData13);

    const newCollectionRefTips = collection(userDocRef, "tips");
    const newData14 = {
      quizFinished: false,
    };
    await setDoc(doc(newCollectionRefTips, userId), newData14);

    const newCollectionRefLicensing = collection(userDocRef, "licensing");
    const newData15 = {
      quizFinished: false,
    };
    await setDoc(doc(newCollectionRefLicensing, userId), newData15);

    const newCollectionRefWhiteline = collection(userDocRef, "whiteline");
    const newData16 = {
      quizFinished: false,
    };
    await setDoc(doc(newCollectionRefWhiteline, userId), newData16);

    const newCollectionRefChanging = collection(userDocRef, "changing");
    const newData17 = {
      quizFinished: false,
    };
    await setDoc(doc(newCollectionRefChanging, userId), newData17);

    const newCollectionRefOvertaking = collection(userDocRef, "overtaking");
    const newData18 = {
      quizFinished: false,
    };
    await setDoc(doc(newCollectionRefOvertaking, userId), newData18);

    const newCollectionRefDriving = collection(userDocRef, "driving");
    const newData19 = {
      quizFinished: false,
    };
    await setDoc(doc(newCollectionRefDriving, userId), newData19);
  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};

const sendPasswordReset = async (email) => {
  try {
    await sendPasswordResetEmail(auth, email);
    alert("Password reset link sent!");
  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};

const logout = () => {
  signOut(auth);
};

const deleteAuthData = async () => {
  const user = auth.currentUser;

  if (user) {
    try {
      // Delete the user's authentication data
      await user.delete();
      console.log("User authentication data deleted successfully");
    } catch (error) {
      console.error("Error deleting user authentication data:", error);
      // Handle the error, e.g., display an error message to the user
    }
  } else {
    console.error("No user is currently logged in");
    // Handle the case where no user is logged in
  }
};

export {
  app,
  auth,
  db,
  firestore,
  signInWithGoogle,
  logInWithEmailAndPassword,
  registerWithEmailAndPassword,
  sendPasswordReset,
  logout,
  doc,
  setDoc,
  updateDoc,
  getDoc,
  collection,
  deleteAuthData,
};
